import { useNavigate } from 'react-router-dom';
import { TemplateMeta } from '../../lib/api';
import { Badge } from '../Common/Badge';

interface Props {
  template: TemplateMeta;
}

export function TemplateCard({ template }: Props) {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate(`/templates/${template.key}`)}
      className="bg-surface border border-border rounded-lg p-4 text-left hover:border-accent transition-colors"
    >
      <div className="flex items-center justify-between mb-1">
        <div className="text-sm font-medium text-text-primary">{template.name}</div>
        <Badge variant="neutral">{template.chartType}</Badge>
      </div>
      <div className="text-xs text-text-muted leading-relaxed">{template.description}</div>
      <div className="text-[10px] uppercase tracking-wider text-text-hint mt-3">
        {template.dataSource === 'warehouse' ? 'Warehouse (daily)' : 'AdvancedMD (live)'}
      </div>
    </button>
  );
}
